import axios from "axios";

export const getRequestsAPI = ({page, limit, status}) => {
    let filteredQuery = '';
    if(status && status != 'all') {
        filteredQuery = `&status=${status}`
    }

    return axios.get(`{server}/admin/users/providers/requests?page=${page}&limit=${limit}${filteredQuery}`).then(res => res.data.success)
}